export default {
  imprint: "Imprint",
  ndaAgreement: "Non-Disclosure Agreement",
  privacyPolicy: "Privacy Policy",
  requestACall: "Request a call",
  viewEnquiries: "View enquiries",
};
